import { render, staticRenderFns } from "./FacebookIcon.vue?vue&type=template&id=94593ee6&"
import script from "./FacebookIcon.vue?vue&type=script&lang=js&"
export * from "./FacebookIcon.vue?vue&type=script&lang=js&"
import style0 from "./FacebookIcon.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports